import { configureStore } from '@reduxjs/toolkit';
import homeReducer from '../redux/homeSlice';

// Configure the store
const store = configureStore({
    reducer: {
        home: homeReducer,
    },
});

// Export the store type to use with TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;